export const MAX_NODE_ENTITY_TYPE_TITLE_LENGTH = 7;
export const MAX_NODE_VALUE_LENGTH = 30;
